import { ProjectIntegration } from "@services/integrations-service/integrations-service-types";
import { isProjectIntegration } from "@services/integrations-service/integrations-type-guards";

/**
 * @returns Whether the passed value is a projectIntegration entity with a defined bcfProjectId
 * @param projectIntegration value to check
 */
export function isProjectIntegrationDefined(
  projectIntegration?: ProjectIntegration | null
): boolean {
  return (
    isProjectIntegration(projectIntegration) &&
    typeof projectIntegration.bcfProjectId === "string" &&
    projectIntegration.bcfProjectId.length > 0
  );
}
